export default __webpack_public_path__ + "static/media/affligem_background_m2.06fe0ce3.jpg";